import React from 'react'

export default function CompareProduct(props) {
  
  const {id} = props.el

  return (
    <div>
      <i className="fal fa-random"></i>
    </div>
  )
}